const manualOrders = {
    cash: 'Cash',
    "credit-card": "Card",
    "wristband-rfid": "Wristband",
    addToCart: 'Add to cart',
    paymentMethod: 'Payment method',
    history: 'History',
    currentOrder: 'Current order',
    logOut: 'Log out',
    pay: 'Pay',
    saveAsADraft: 'Save as a draft',
    deleteOrder: 'Delete order',
    order: 'Order',
    paymentConfirmation: 'Payment confirmation',
    cancel: 'Cancel',
    markAsPaid: 'Mark as paid',
    theTotalIs: 'The total is',
    cashPaymentConfirmation: 'You can use the field below to find out the change. Remember to mark the order as paid when done.',
    "wristband-rfidPaymentConfirmation": 'Tell the customer to bring their wristband close to the sensor.',
    "credit-cardPaymentConfirmation": 'Please, proceed with your POS and mark the order as paid when done.',
    change: 'Change',
    eg: 'eg',
    paidWith: 'Paid with',
    selectAPaymentMethod: 'Please, select a payment method',
    somethingWentWrong: 'Something went wrong',
    markedAsPaid: 'Marked as paid',
    "applyADiscount?": 'Apply a discount?',
    discount: 'Discount',
    free: 'Free',
    draftOrders: 'Draft orders',
    loadedOrder: 'Loaded order',
    in_progress: 'Draft',
    processing: 'Processing',
    on_going: 'On going',
    completed: 'Completed',
    succeeded: 'Received',
    invalid: 'Invalid',
    refunded: 'Refunded',
    transferred: 'Transferred',
    collapse: 'Collapse',
    close: 'Close',
    buy: 'Buy',
    eventNotFound: 'Event not found',
    cartIsEmpty: 'Cart is empty.\nTry adding something 🍸!',
    minimumOrderIs: 'Minimum order is {{totalPrice}}',
    'dontWannaMove?': 'Don\'t wanna move?',
    deliverToMyPlace: 'Deliver to my place',
    addDelivery: 'Add delivery',
    addDeliveryExplanation: 'Please, specify where your order has to be delivered. We need this to be able to locate you.',
    seating: 'Seating',
    eg: 'eg',
    deliverTo: 'Deliver to',
    removeDelivery: 'Remove delivery',
    removeDeliveryExplanation: 'Remove delivery to {{delivery}}?',
    remove: 'Remove',
    deliveryModalTitle: 'Want your order to be delivered?',
    modify: 'Modify',
    soldOut: 'Sold out',
    signIn: 'Sign in',
    welcomeBack: 'Welcome back!',
    activeOrders: 'Active orders',
    pastOrders: 'Past orders',
    profileDrawerSignInCopy: "Don't have an account yet? Sign in and get your order even faster!",
    product: 'product',
    products: 'products',
    bringItToVipZone: 'Bring it to VIP zone',
    somethingOutOfStock: "There's something out of stock",
    salesAreNotAvailable: 'Sales are not available',
    from: 'From',
    selectOneOption: 'Please, select one option',
    glassModalTitle: 'Do you want a reusable glass?',
    addGlassExplanation: 'You need a reusable glass in order to recieve your drinks',
    glass: 'glass',
    glasses: 'glasses',
    continue: 'Continue',
    continueWithoutGlasses: 'Continue without glasses',
    dontShowAgain: 'Don\'t show again',
    notice: 'Notice',
    bannedAlcohol: 'It is illegal to sell alcohol to anyone under the age of 18.',
    myOrders: 'My orders',
    finalPrice: 'Final price',
    total: 'Total',
    addNItems: 'Add {{n}} items to cart',
    menuChanged: 'Menu changed',
    menuChangedMessage: 'The menu has changed. Some products are no longer available. Your cart is no longer available, sorry for the inconvenience.',
    Accept: 'Accept',
    checkCart: 'Check cart',
    packUsesExhausted: 'A pack you selected is out of stock',
    goToVoting: 'Go to voting',
    maximumOrderIsExceeded: 'You cannot expend more than {{maximumOrderAmount}}',
    maximumItemsPerOrderExceeded: 'You cannot order more than {{maximumItemsPerOrder}} items',
}


const promotions = {
    allVenues: 'All venues',
    spending: 'Spending',
    usesLeft: '{{uses}} left',
    promotions: 'Promotions',
    promo: 'Promo',
    discountOff: '{{discount}} off',
    couponAvailable: 'Coupon available',
    'haveACode?': 'Have a code?',
    'haveADiscount?': 'Have a discount?',
    addDiscount: 'Add discount',
    addItHere: 'Add it here',
    discountCode: 'Discount code',
    send: 'Send',
    invalidCode: 'Invalid code',
    promotionAdded: 'Promotion added',
    applyingPromotions: 'Applying',
    andNMore: 'and {{n}} more',
    skipThisStep: 'Skip this step',
}

const dates = {
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "twoDaysAgo": "Two days ago",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "theDay": "On {{day}}",
    "thePastDay": "Last {{day}}",
    "theFutureDay": "Next {{day}}",
    "midString": "{{weekday}}, {{month}} {{date}}",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "momentAgo": "A while ago",
    "weekAbbreviation": "w",
    "year": "year",
    "years": "years",
    "longDate": "{{date}} of {{month}} of {{fullYear}}",
    "mondayAbbreviation": "Mon",
    "tuesdayAbbreviation": "Tue",
    "wednesdayAbbreviation": "Wed",
    "thursdayAbbreviation": "Thu",
    "fridayAbbreviation": "Fri",
    "saturdayAbbreviation": "Sat",
    "sundayAbbreviation": "Sun",
    "mondayLetter": "M",
    "tuesdayLetter": "T",
    "wednesdayLetter": "W",
    "thursdayLetter": "T",
    "fridayLetter": "F",
    "saturdayLetter": "S",
    "sundayLetter": "S",
};


const englishTranslateJSON = {
    ...manualOrders,
    ...promotions,
    ...dates
};

export default englishTranslateJSON;
